import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import Clients from './pages/Clients'
import Devices from './pages/Devices'
import DeviceMonitoring from './pages/DeviceMonitoring'
import Events from './pages/Events'
import PrivateRoute from './components/PrivateRoute'

function App() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)

  return (
    <Routes>
      <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />
      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/monitoring" element={<DeviceMonitoring />} />
          <Route path="/events" element={<Events />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default App